module.exports = __webpack_public_path__ + "static/media/alcohol@3x.a13c0b02.png";